import classNames from 'classnames';
import { ChevronDown } from 'lucide-react';
import type { TFunction } from 'next-i18next';
import { Trans } from 'next-i18next';
import { useState } from 'react';

import { ScrollArea } from '@/components/ui/scroll-area';

interface FaqProps {
  t: TFunction;
  daysTrial: number;
}

const Faq = ({ t, daysTrial }: FaqProps) => {
  const [activeFaq, setActiveFaq] = useState<number | null>(null);
  const questions = t('faq', { ns: 'components/faq', returnObjects: true });

  return (
    <section className='mx-auto flex w-full flex-col items-center justify-center px-5 mobile:py-20'>
      <h3 className='mb-10 text-center text-5xl font-bold leading-10 text-white tablet:text-7xl'>{t('seventh_section.text01')}</h3>

      <div className='flex w-full flex-col items-center justify-center bg-[url(/assets/images/trial/new/bg-second-section.webp)] bg-cover bg-center bg-no-repeat py-20'>
        <div className='flex w-full max-w-[1320px] flex-col items-center justify-center gap-6'>
          {Object.entries(questions)
            .slice(0, 6)
            .map(([key, _item], index) => (
              <div key={key} className={classNames('flex w-full cursor-pointer flex-col items-start')} onClick={() => setActiveFaq(index !== activeFaq ? index : null)}>
                <div className='flex w-full items-center justify-between rounded-t-[20px] bg-[#424A5B] p-5 text-start'>
                  <p className='text-lg font-bold uppercase text-white mobile:text-3xl'>
                    {(() => {
                      if (index === 1) {
                        return <Trans i18nKey='seventh_section.faq.q1.question' ns='pages/trial-matrix' count={daysTrial || 1} />;
                      }
                      return <Trans i18nKey={`faq.${index}.question`} ns='components/faq' count={daysTrial || 1} />;
                    })()}
                  </p>
                  <div className='ms-auto'>
                    <ChevronDown className={classNames('text-white', activeFaq === index && 'rotate-180')} />
                  </div>
                </div>
                <div className={classNames('flex w-full bg-[#1D2028] p-5', activeFaq !== index && 'py-0')}>
                  <ScrollArea className={classNames('flex-1', activeFaq === index ? 'max-h-48' : 'h-0')} colorScroll='bg-[#AEF55C]'>
                    <div className='overflow-hidden text-zinc-300 transition'>
                      <p className='pe-4 text-lg font-normal text-white tablet:text-xl'>
                        {(() => {
                          if (index === 1) {
                            return <Trans i18nKey='seventh_section.faq.q1.answer' ns='pages/trial-matrix' count={daysTrial || 1} components={{ br: <br />, strong: <strong className='text-green-300' /> }} />;
                          }
                          if (index === 2) {
                            return <Trans i18nKey='seventh_section.faq.q2.answer' ns='pages/trial-matrix' count={daysTrial || 1} components={{ br: <br />, strong: <strong className='text-green-300' /> }} />;
                          }
                          return <Trans i18nKey={`faq.${index}.answer`} ns='components/faq' count={daysTrial || 1} components={{ br: <br />, strong: <strong className='text-green-300' /> }} />;
                        })()}
                      </p>
                    </div>
                  </ScrollArea>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export { Faq };
